import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import transactions from '../../../test/transactions'
import sample from './sample.json';


/**
 * id
 * name
 * description
 * invokedTransactions: [ {id, order} ]
 * nestedTransactions: [ {id, order} ]
 * templateTransactions: [ {name, order} ]
 * events: [ {id, order} ]
 * clusterlets: [ id, order, category: userdefined/templateclusterlet ]
 */

const initialState = []//transactions


export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case types.ADD_TRANSACTION: {
            return [
                ...state,
                action.payload
            ]
        }

        case types.EDIT_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.id) {
                    return { ...t, name: action.payload.name, description: action.payload.description, clusterlets: action.payload.clusterlets, events: action.payload.events }
                } else {
                    return { ...t }
                }
            })
        }

        case types.DELETE_TRANSACTION: {
            return state.filter(transaction => transaction.id !== action.payload.id)
        }

        case types.ADD_NESTEDTRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.id) {
                    return { ...t, nestedTransactions: [...t.nestedTransactions, action.payload.data] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.EDIT_NESTEDTRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.id) {
                    return { ...action.payload }
                } else {
                    return { ...t }
                }
            })
        }


        case types.DELETE_NESTEDTRANSACTION: {
            return state.filter(transaction => transaction.id !== action.payload.id)
        }

        case types.DELETE_NESTEDTRANSACTION_LINK: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, nestedTransactions: [...t.nestedTransactions.filter((nt) => nt.id !== action.payload.nestedTransactionId)] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.ADD_INVOKEDTRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, invokedTransactions: [...t.invokedTransactions, action.payload.invokedTransaction] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.EDIT_INVOKEDTRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return {
                        ...t, invokedTransactions: [...t.invokedTransactions.map(nt => {
                            if (nt.id == action.payload.invokedTransaction.id) {
                                return { ...nt, condition: action.payload.invokedTransaction.condition }
                            }
                            else {
                                return { ...nt }
                            }
                        })]
                    }
                } else {
                    return { ...t }
                }
            })
        }

        case types.DELETE_INVOKEDTRANSACTION: {

            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, invokedTransactions: [...t.invokedTransactions.filter((nt) => nt.id !== action.payload.invokedTransId)] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.REORDER_CLUSTERLETS: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, clusterlets: action.payload.clusterletArray }
                } else {
                    return { ...t }
                }
            })
        }

        case types.ADD_EVENT_TO_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, events: [...t.events, action.payload.event] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.DELETE_EVENT_FROM_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.transactionId) {
                    return { ...t, events: [...t.events.filter(ev => ev.id != action.payload.eventId)] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.ADD_TEMPLATE_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, templateTransactions: [...t.templateTransactions, action.payload.templateTransaction] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.DELETE_TEMPLATE_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, templateTransactions: [...t.templateTransactions.filter((tt) => tt.invokeId !== action.payload.templateTransactionInvokeId)] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.REMOVE_TEMPLATE_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.selectedTransactionId) {
                    return { ...t, templateTransactions: [...t.templateTransactions.filter((tt) => !action.payload.templateClusterletIds.includes(tt.templateId))] }
                } else {
                    return { ...t }
                }
            })
        }

        case types.UPDATE_FULL_TRANSACTIONS: {
            return [
                ...state,
                ...action.payload
            ]
        }

        case types.RESET_TRANSACTIONS: {
            return [
                // ...state,
                ...action.payload
            ]
        }

        case types.ADD_CLUSTERLET_TO_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.transactionId) {
                    return { ...t, clusterlets: [...t.clusterlets, action.payload.clusterlet], }
                } else {
                    return { ...t }
                }
            })
        }

        case types.REMOVE_CLUSTERLET_FROM_TRANSACTION: {
            return state.map(t => {
                if (t.id == action.payload.transactionId) {
                    return { ...t, clusterlets: [...t.clusterlets.filter((clusterlet) => clusterlet.id !== action.payload.clusterletId)], }
                } else {
                    return { ...t }
                }
            })
        }

        case types.EDIT_EVENT_ORDER: {
            console.log('action.payload---->', action.payload, state)
            return state.map(t => {
                if (t.id == action.payload.transactionId) {
                    return {
                        ...t, events: [...(t.events.map(ev => {
                            if (ev.id == action.payload.event.id) {
                                ev.order = action.payload.event.order
                            }
                            return ev
                        }))],
                    }
                } else {
                    return { ...t }
                }
            })
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);


        default:
            return state;
    }
}
